import React, { Component } from "react";
import PropTypes from "prop-types";
import Layout from "../Layout";
import { Layout4 } from "../ContentBox";
import { DivHover, DivHelp } from "./styled";

class AvatarView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false
    };
  }
  onHover = () => {
    this.setState({ hover: true });
  };
  onMouseOver = () => {
    this.setState({ hover: false });
  };
  render() {
    return (
      <DivHover
        onMouseLeave={this.onMouseOver.bind(this)}
        onMouseEnter={this.onHover.bind(this)}
      >
        <Layout {...this.props} type="AvatarView" />
        {this.state.hover && <DivHelp>Content</DivHelp>}
      </DivHover>
    );
  }
}

AvatarView.propTypes = {
  childOf: PropTypes.string,
  values: PropTypes.object,
  cell: PropTypes.array,
  layout: PropTypes.func
};

AvatarView.defaultProps = {
  childOf: "Content",
  values: {
    parent: "Content",
    type: "AvatarView",
    url: "",
    containerPadding: "0px",
    size: 100,
    align: "center",
    href: {
      url: "",
      target: "",
      isCollection: false,
      collection:0
    }
  },
  layout: Layout4
};
export default AvatarView;



// WEBPACK FOOTER //
// ./src/editor/layout/components/Content/AvatarView.js